import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postLiveAccount = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/account-livestream`, data: payload });

  return data;
};

export default postLiveAccount;
